export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/Block4-231436027482c49a37322f6eb098f15d.png";